<template>
  <div id="detailPage" class="detailPage">
    <!-- <button @click="daochu('detailPage', factoryToolsDetailData.orderNumber)">导出</button> -->
    <p class="title">基本信息</p>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">工具名称：</div>
        <div class="right">
          <span class="value" v-if="factoryToolsDetailData.name">{{
            factoryToolsDetailData.name
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">产品类型：</div>
        <div class="right">
          <span class="value" v-if="factoryToolsDetailData.productType"
            >{{ factoryToolsDetailData.productType.title }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最低版本：</div>
        <div class="right">
          <span class="value" v-if="factoryToolsDetailData.minBuild">
            {{factoryToolsDetailData.minBuild}}
            </span>
        </div>
      </li>
      <li>
        <div class="left">最新版本：</div>
        <div class="right">
          <span v-if="factoryToolsDetailData.latestBuild>0 && factoryToolsDetailData.url" class="allowSkip" @click="downloadFile(factoryToolsDetailData.url)">{{ factoryToolsDetailData.latestBuild }}</span>
          <span v-else-if="factoryToolsDetailData.latestBuild>0 && !factoryToolsDetailData.url">{{ factoryToolsDetailData.latestBuild }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li class="blockLi">
        <div class="left">工具说明：</div>
        <div class="right">
          <span class="value" v-if="factoryToolsDetailData.description"
            >{{ factoryToolsDetailData.description }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div class="titleBox">
      <p class="title">历史版本</p>
    </div>
    <ul class="ulBox clearFloat">
      <li class="blockLi">
        <div class="right">
          <el-table
            class="myProductionOrder"
            stripe
            :data="factoryToolsHisData"
            border
            style="width: 100%"
            size="mini"
          >
            <el-table-column  label="版本号"
              prop="minBuild" min-width="100" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.minBuild">
                  {{scope.row.minBuild}}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="发布时间"
              prop="pushDate" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.pushDate">{{ scope.row.pushDate }} {{ scope.row.pushTime }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="发布者" prop="pushUserName" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.pushUserName">{{ scope.row.pushUserName }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="版本说明" prop="description" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.description">{{ scope.row.description }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"
              class-name="operation" align="center" width="95px">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="下载" placement="top" :open-delay="300">
                  <i v-if="scope.row.url"
                    class="el-icon-download"
                    @click="downloadFile(scope.row.url)">
                  ></i>
                </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="设为最低版本" placement="top" :open-delay="300">
                  <i v-if="scope.row.url"
                     class="iconfont icon-banbenhao"
                     @click="editVersionBtn($event, scope.row)">
                    ></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
                  <i v-if="scope.row.url"
                     class="el-icon-edit"
                     @click="factoryVerToolsEdit($event, scope.row)">
                    ></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
    </ul>

    <myDialog ref="verDialog"
              :title="dialogTitle" @submitData="submitData" @dialogClose="dialogClose">
      <template slot="content">
        <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" :label-width="labelWidth">
          <el-form-item label="版本号" size="small" prop="minBuild">
            <el-input :value="dialogForm.minBuild"
                      @input="formatNumber($event, 'dialogForm', 'minBuild')" placeholder="版本号" clearable></el-input>
          </el-form-item>
          <el-form-item label="安装包" size="small" prop="uploadFile" class="uploadBox">
            <input ref="fileUpload"
                   class="fileUpload" type="file" @change="fileChange('fileUpload')"/>
            <span class="fileText textOverflow">{{ fileText }}</span>
          </el-form-item>
          <el-form-item label="版本说明" size="small" prop="description">
            <el-input v-model="dialogForm.description"
                      type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="描述本次版本更新内容或解决的问题"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import {
  apiFactoryToolDetail, 
  apiFactoryToolsHisAdd,
  apiFactoryToolsHisEdit,
  apiFactoryToosHisSearch,
  apiToolsUpdateVersion,
} from "@/api/factoryTools.js";
import myDialog from "@/components/myDialog";
import {apiUploadFile} from "@/api/filesUpload";
export default {
  props: {
    factoryToolId: { type: String },
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
  },
  components: {
    myDialog,
  },
  data() {
    return {
      factoryToolsDetailData: {},
      factoryToolsHisData:[],
      pullDownData: {
        productOrderList: [],
      },
      dialogVisible: false,
      dialogTitle: "",
      dialogForm: {
      },
      dialogRules: {
        minBuild: [
          { required: true, message: "版本号不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
      fileText: "未选择任何文件",
    };
  },
  methods: {
    // 表格数据
    async getFactoryToolsHisSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.factoryToolsHisData = [];
      }
      const res = await apiFactoryToosHisSearch({
        factoryToolId: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.factoryToolsHisData = res.data;
        if (callback) callback();
      }
    },
    // 发布版本
    factoryVerToolsAdd() {
      this.dialogTitle = "发布版本";
      this.$refs.verDialog.dialogVisible = true;
      this.fileText = "未选择任何文件";
    },
    // 修改版本
    factoryVerToolsEdit(e,row) {
      this.dialogTitle = "修改版本";
      this.$refs.verDialog.dialogVisible = true;
      
      this.dialogForm={
        id:row.id,
        fid:row.fid,
        minBuild:row.minBuild,
        description:row.description
      }
      this.fileText = row.fileName ? row.fileName : "未选择任何文件";
    },
    // 修改最低版本号
    editVersionBtn(e,row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = "请输入版本号:【";
      const st = row.minBuild;
      this.$msgbox({
        title: `提示！`,
        message: h("div", null, [
          h(
              "span",
              null,
              tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确定将该版本设为最低版本！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiToolsUpdateVersion({
          id: this.tabPaneValue,
          minBuild: row.minBuild,
        });
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.factoryToolsDetailData.minBuild = row.minBuild;
        }
      });
    },
    // 格式化整数
    formatNumber(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      this.$set(this[formName], name, newValue);
    },
    // 文件上传
    async fileChange(refName) {
      this.$set(this.dialogForm, "uploadFile", this.$refs[refName].files[0]);
      this.$refs.dialogForm.validateField("uploadFile");
      let file = this.$refs[refName].files[0];
      // console.log(file)
      if (file) {
        this.$set(this.dialogForm, "fid", null);
        this.fileText = file.name;
      }
    },
    // 文件下载
    downloadFile(url) {
      let a = document.createElement("a");
      a.href = url;
      a.style.display = "none";
      a.target = "_blank"
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 导出
    // daochu(nodeId, downloadName) {
    //   this.$canvasDownload(nodeId, downloadName)
    // },
    // 订单详情
    async getFactoryToolsDetail(callback) {
      const res = await apiFactoryToolDetail({
        id: this.tabPaneValue,
      });
      // console.log(res);
      if (res.code == 0) {
        this.factoryToolsDetailData = res.data;
        // this.$parent.detailData = res.data;
        if (callback) callback();
      }
    },
    // 确认发布版本
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "发布版本") {
            let res = {};
            let fd = new FormData();
            fd.append("file", this.dialogForm.uploadFile);
            res = await apiUploadFile(fd);
            if (res.code == 0) {
              this.$set(this.dialogForm, "fid", res.fid);
            } else {
              return false;
            }
            res = await apiFactoryToolsHisAdd({
              factoryToolId: this.tabPaneValue,
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.verDialog.dialogVisible = false;
              this.getFactoryToolsDetail();
              this.getFactoryToolsHisSearch("noRemove");
              this.$message({
                message: "新增成功",
                type: "success",
              });
            }
          }
          if (title == "修改版本") {
            let res = {};
            if(!this.dialogForm.fid){
              let fd = new FormData();
              fd.append("file", this.dialogForm.uploadFile);
              res = await apiUploadFile(fd);
              if (res.code == 0) {
                this.$set(this.dialogForm, "fid", res.fid);
              } else {
                return false;
              }
            }
            res = await apiFactoryToolsHisEdit({
              factoryToolId: this.tabPaneValue,
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.verDialog.dialogVisible = false;
              this.getFactoryToolsDetail();
              this.getFactoryToolsHisSearch("noRemove");
              this.$message({
                message: "新增成功",
                type: "success",
              });
            }
        }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
      this.pullDownData.productOrderList = [];
    }
  }
};
</script>

<style lang="less" scoped>
//.myProductionOrder {
//  /deep/.el-table__body-wrapper {
//    tbody {
//      .el-table__row:last-child {
//        font-weight: 700;
//      }
//    }
//  }
//}
.uploadBox {
    position: relative;
    .fileText {
      width: 250px;
      position: absolute;
      top: 0;
      left: 73px;
      background-color: var(--bgPanel);
    }
  }
</style>
